
var Licence = (function () {
  const MILLIS_PER_DAY = 1000 * 60 * 60 * 24;

  var licenceAcceptName = "snomed-sublicence-accepted",
    licenceRejectName = "snomed-sublicence-rejected",
    licenceRedirect,
    redirectParams = 'tour=true';

  return {
    init: function () {
      // check for licence acceptance
      if (!window.location.href.endsWith('licence.html') && !localStorage.getItem(licenceAcceptName)) {
        const accepted = new Date(localStorage.getItem(licenceAcceptName) || null).getTime();
        const now = new Date().getTime();
        if (now - accepted > MILLIS_PER_DAY * 365) {
          window.location.href = "licence.html";
        }
      }
      licenceRedirect = document.referrer || ".";
    },

    licenceCheck: function () {
      const accept = localStorage.getItem(licenceAcceptName) || null;
      const reject = localStorage.getItem(licenceRejectName);
      const expired = !accept || (new Date().getTime() - new Date(accept).getTime()) > MILLIS_PER_DAY * 365;

      if (!expired) {
        const expiry = new Date(accept || null);
        expiry.setFullYear(expiry.getFullYear() + 1);   // Expire in one year

        document.getElementById("rejection").style.display = "none";
        document.getElementById("datestamp").innerHTML = expiry;
        document.getElementById("accept").style.display = "none";
        document.getElementById("acknowledgement").style.display = "block";

        document.getElementById("continueLink").href = licenceRedirect;

        if (licenceRedirect.indexOf("tour=true") >= 0) {
          // Only auto-redirect on first agreement
          setTimeout(function () {
            window.location.href = licenceRedirect; //will redirect to Shrimp in 2 sec
          }, 2000);
        }
      } else if (reject) {
        document.getElementById("acknowledgement").style.display = "none";
        document.getElementById("rejection").style.display = "block";
      }
    },

    licenceSubmit: function (answer) {
      if ("YES" === answer) {
        const previousAccept = localStorage.getItem(licenceAcceptName) || null;

        localStorage.removeItem(licenceRejectName);
        localStorage.setItem(licenceAcceptName, new Date().toISOString());
        if (!previousAccept) {   // run tour on first time
          if (licenceRedirect.indexOf("?") >= 0) {
            licenceRedirect = licenceRedirect + '&' + redirectParams;
          } else {
            licenceRedirect = licenceRedirect + '?' + redirectParams;
          }
        }
      } else {
        localStorage.removeItem(licenceAcceptName);
        localStorage.setItem(licenceRejectName, new Date().toISOString());
      }
      this.licenceCheck();
    },

  };
})();
